<template>
  <div>
    <div class="columns toolbar-box action-right">
      <div class="column is-3">
        <h1 class="title is-3 between-center">
                    <span>
                        <span>Referrals</span>
                    </span>
        </h1>
      </div>
      <div class="column is-4-tablet is-2-desktop">
        <o-field>
          <o-input
              type="search"
              v-model="filters.name"
              placeholder="Name"
              @update:modelValue="fetchReportData()"
          ></o-input>
        </o-field>
      </div>
      <div class="column is-4-tablet is-2-desktop">
          <o-field>
            <Datepicker
                v-model="filters.from"
                class="input"
                @update:modelValue="fetchReportData()"
                placeholder="Date start"/>
          </o-field>
      </div>
      <div class="column is-4-tablet is-2-desktop">
        <o-field>
          <o-field>
            <Datepicker
                v-model="filters.to"
                class="input"
                @update:modelValue="fetchReportData()"
                placeholder="Date end"/>
          </o-field>
        </o-field>
      </div>
      <div class="column is-4-tablet is-2-desktop">
        <div class="field is-grouped is-grouped-right">
          <p v-if="isResetFiltersButtonVisible" class="control">
            <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
          </p>
        </div>
      </div>
    </div>

        <o-table
            table-class="report-table"
            :data="rows"
            :loading="loading"
            :total="total"
            :per-page="perPage"
            paginated
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @page-change="onPageChange"
            @sort="onSort">
          <template>
            <template>
              <o-table-column
                  #default="{row}"
                  v-for="(col, idx) in columns" :key="idx + '_' + col.field"
                  :field="col.field"
                  :label="col.label"
                  :sortable="col.sortable">
                <span v-if="col.money">{{ $filters.currency(row[col.field]) }}</span>
                <router-link v-else-if="col.field === 'project_name'" :to="{ name: 'projects.show', params: { slug: row['project_id']} }">
                  {{ $filters.valueOrDefault(row[col.field]) }}
                </router-link>
                <span v-else>{{ row[col.field] }}</span>
              </o-table-column>
            </template>
          </template>
          <template #footer>
<!--            <th>Total</th>-->
            <th v-for="col in columns"  :key="col.field">
              <span v-if="col.field === 'date_created'">Total</span>
              <span v-if="col.field === 'amount'">{{ $filters.currency(summary[col.field]) }}</span>
              <span v-else>-</span>
            </th>
          </template>
        </o-table>

        <div>Total: <strong>{{ total }}</strong></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Table from '../../mixins/Table'
import Datepicker from '../../components/Datepicker'
import _ from "lodash";

export default {
  mixins: [Table],

  components: {
    Datepicker
  },

  created () {
    this.filters = {
      from: '',
      to: '',
      name: ''
    }
  },

  data () {
    return {
      rows: [],
      total: 0,
      loading: false,
      sortField: "name",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      page: 1,
      perPage: 20,
      columns: [],
      summary: null,
    }
  },

  methods: {
    fetchReportData()  {
      this.loading = true;
      let params = {from: this.filters.from, to: this.filters.to, name: this.filters.name}
      axios.get('/api/reports/referrals', { params })
          .then(res => {
            this.rows = res.data.data.referrals;
            this.total = res.data.data.referrals.length;
            this.columns = res.data.data.columns;
            this.loading = false;
            this.summary = res.data.data.summary;
          })
    },

    onPageChange(p) {
      this.page = p;
      this.fetchReportData();
    },

    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
    },

    resetFilters() {
      for (let field in this.filters) {
        this.filters[field] = _.isArray(this.filters[field]) ? [] : ''
      }

      this.fetchReportData();
    },
  },

  computed: {
    ...mapGetters(['years']),

    ...mapGetters({
      itemsByIds: 'companiesByIds'
    }),

    isResetFiltersButtonVisible() {
      for (let field in this.filters) {
        if (this.filters[field]) {
          return true
        }
      }

      return false
    },

  },

  beforeMount() {
    this.fetchReportData()
  },
}
</script>
